<template>
  <div
    class="m-dropdown-content m-dropdown-content-right"
    id="MoleculeTheHeaderSubMenuDropDownUser"
  >
    <header class="m-dropdown-header">
      <span class="m-dropdown-title text-color-billing-primary">
        {{ usuario.nombre }}
      </span>
      <span class="m-dropdown-subtitle">
        {{ usuario.email }}
      </span>
    </header>
    <section class="m-dropdown-section">
      <ul class="m-dropdown-list">
        <li>
          <a
            href="logout"
            @click.prevent="$auth.logout()"
          >
            <span class="m-dropdown-item-icon">
              <i class="far fa-arrow-alt-right text-color-danger"></i>
            </span>
            <span class="m-dropdown-item-text">
              Cerrar Sesión
            </span>
          </a>
        </li>
      </ul>
    </section>
  </div>
</template>

<script>
export default {
  name: 'MoleculeTheHeaderSubMenuDropDownUser',

  props: {
    academiasUsuario: Array
  },

  data () {
    return {
      usuario: {
        email: '',
        nombre: ''
      }
    }
  },

  created () {
    this.usuario.email = this.$store.getters.getUserData.email
    this.usuario.nombre = this.$store.getters.getUserData.name
  }
}
</script>
